
const MUIZK_READ = process.env.VUE_APP_MUIZK_READ
const MUZIK_DOMAIN = process.env.VUE_APP_MUZIK_DOMAIN
// Lazy loading
const Layout = () => import(/* webpackChunkName: "Layout" */ '@/layouts/Layout')
// const Read = () => import(/* webpackChunkName: "Read" */ '@/pages/_locale/Read')
const ArticleById = () => import(/* webpackChunkName: "ArticleById" */ '@/pages/_locale/articles/_id')
const AuthorById = () => import(/* webpackChunkName: "AuthorById" */ '@/pages/_locale/authors/_id')
const AuthorList = () => import(/* webpackChunkName: "AuthorList" */ '@/pages/_locale/authors/index')
const TagById = () => import(/* webpackChunkName: "TagById" */ '@/pages/_locale/tags/_id')
const PeriodicalArticleById = () => import(/* webpackChunkName: "PeriodicalArticleById" */ '@/pages/_locale/periodicalArticles/_id')
// Read event
const ContemporaryMusic2019 = () => import(/* webpackChunkName: "ContemporaryMusic2019" */ '@/pages/_locale/event/ContemporaryMusic2019')

const readMetaImage = `https://${MUIZK_READ}.${MUZIK_DOMAIN}/img/cover-social/read.png`

const readRoutes = [
  // /////////////////////////
  // Migration from 閱古典
  // /////////////////////////
  {
    path: '/:locale/news', // news (common) 文章 頁面
    redirect: '/:locale/'
  },
  {
    path: '/:locale/news/:id', // 文章 頁面
    redirect: '/:locale/articles/:id'
  },
  {
    path: '/:locale/news/page/:page', // 文章 分頁
    redirect: '/:locale/'
  },
  {
    path: '/:locale/news/:garbage_path/:id', // 文章 special case
    redirect: '/:locale/articles/:id'
  },
  // //////////////////////////
  {
    path: '/:locale/recommend', // recommend 列表頁面
    redirect: '/:locale/'
  },
  {
    path: '/:locale/recommend/page/:page', // recommend 分頁
    redirect: '/:locale/tags/8babbd82-a7ec-40fe-898e-33587e074c11'
    // redirect: '/:locale/'
  },
  {
    path: '/:locale/recommend/:id', // recommend 文章頁
    redirect: '/:locale/articles/:id'
  },
  // //////////////////////////
  {
    path: '/:locale/expert', // expert 列表頁面
    redirect: '/:locale/'
  },
  {
    path: '/:locale/expert/page/:page', // expert 分頁
    redirect: '/:locale/tags/8babbd82-9f0b-4e8b-b57e-96a627c8a887'
    // redirect: '/:locale/'
  },
  {
    path: '/:locale/expert/:id', // expert 文章頁
    redirect: '/:locale/articles/:id'
  },
  // //////////////////////////
  {
    path: '/:locale/author/page/:page', // 閱古典 作者列表 分頁
    redirect: '/:locale/authors'
  },
  {
    path: '/:locale/author/:id/page/:page', // 閱古典 作者 分頁
    alias: '/:locale/authors/:id/page/:page',
    redirect: '/:locale/authors/:id'
  },
  {
    path: '/:locale/event', // news (common) 文章 頁面
    redirect: '/:locale/'
  },
  // ///////////////////////////////////////////////////////////
  // ///////////////////////////////////////////////////////////
  // {
  //   path: '/:locale/',
  //   // redirect: to => {
  //   //   window.location.href = 'https://read.muzikair.com' + `/${to.params.locale}`
  //   // }
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'read',
  //       component: Read,
  //       meta: {
  //         requiresAuth: false,
  //         breadcrumbs: [],
  //         metaInfo: {
  //           title: 'READ.TITLE',
  //           meta: [
  //             { vmid: 'image', name: 'image', content: readMetaImage },
  //             { vmid: 'og:image', name: 'og:image', content: readMetaImage }
  //           ]
  //         }
  //       }
  //     }
  //   ]
  // },
  {
    path: '/:locale/articles',
    component: Layout,
    children: [
      {
        path: '',
        redirect: '/:locale/'
      },
      {
        path: ':id',
        name: 'articleById',
        props: true,
        component: ArticleById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            { routeName: 'index', localeLabel: 'READ.TITLE', redirectPath: '' },
            { routeName: '', localeLabel: 'ARTICLE.TITLE', redirectPath: '' } // routeName: 'articleById'
          ],
          metaInfo: {
            title: 'ARTICLES.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: readMetaImage },
              { vmid: 'og:image', name: 'og:image', content: readMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    // alias for articls
    path: '/:locale/article/:id',
    redirect: '/:locale/articles/:id'
  },
  {
    path: '/:locale/periodicalArticles',
    component: Layout,
    children: [
      {
        path: '',
        redirect: '/:locale/'
      },
      {
        path: ':id',
        name: 'periodicalArticleById',
        props: true,
        component: PeriodicalArticleById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            { routeName: 'index', localeLabel: 'READ.TITLE', redirectPath: '' },
            { routeName: '', localeLabel: 'ARTICLE.TITLE', redirectPath: '' }
          ],
          metaInfo: {
            title: 'ARTICLES.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: readMetaImage },
              { vmid: 'og:image', name: 'og:image', content: readMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    path: '/:locale/authors',
    component: Layout,
    children: [
      {
        path: '',
        name: 'authorList',
        component: AuthorList,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            // { routeName: 'index', localeLabel: 'BREADCRUMBS.INDEX', redirectPath: '' },
            { routeName: 'index', localeLabel: 'READ.TITLE', redirectPath: '' },
            { routeName: '', localeLabel: 'AUTHOR.LIST', redirectPath: '' } // routeName: 'authorList'
          ],
          metaInfo: {
            title: 'AUTHOR.LIST',
            meta: [
              { vmid: 'image', name: 'image', content: readMetaImage },
              { vmid: 'og:image', name: 'og:image', content: readMetaImage }
            ]
          }
        }
      },
      {
        path: ':id',
        name: 'authorById',
        component: AuthorById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            // { routeName: 'index', localeLabel: 'BREADCRUMBS.INDEX', redirectPath: '' },
            { routeName: 'read', localeLabel: 'READ.TITLE', redirectPath: '' },
            { routeName: 'authorList', localeLabel: 'AUTHOR.LIST', redirectPath: '/authors' },
            { routeName: '', localeLabel: 'AUTHOR.TITLE', redirectPath: '' } // routeName: 'authorById'
          ],
          metaInfo: {
            title: 'AUTHOR.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: readMetaImage },
              { vmid: 'og:image', name: 'og:image', content: readMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    // alias for authors
    path: '/:locale/author/:id',
    redirect: '/:locale/authors/:id'
  },
  {
    // alias for authors
    path: '/:locale/author',
    redirect: '/:locale/authors'
  },
  {
    path: '/:locale/tags',
    component: Layout,
    children: [
      {
        path: '',
        redirect: '/:locale/'
      },
      {
        path: ':id',
        name: 'tagById',
        component: TagById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            // { routeName: 'index', localeLabel: 'BREADCRUMBS.INDEX', redirectPath: '' },
            { routeName: 'read', localeLabel: 'READ.TITLE', redirectPath: '' },
            { routeName: '', localeLabel: 'TAG.TITLE', redirectPath: '' }
          ],
          metaInfo: {
            title: 'TAG.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: readMetaImage },
              { vmid: 'og:image', name: 'og:image', content: readMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    // alias for tags
    path: '/:locale/tag/:id',
    redirect: '/:locale/tags/:id'
  },
  {
    // alias for tags
    path: '/:locale/event/',
    component: ContemporaryMusic2019,
    children: [
      {
        path: '/',
        redirect: '/:locale/'
      },
      {
        path: 'ContemporaryMusic2019',
        name: 'ContemporaryMusic2019',
        component: ContemporaryMusic2019,
        meta: {
          requiresAuth: false,
          metaInfo: {
            title: 'READ.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: readMetaImage },
              { vmid: 'og:image', name: 'og:image', content: readMetaImage }
            ]
          }
        }
      }
    ]
  }
]

export default readRoutes
